import React from 'react';
import { Card } from 'antd';
import { FolderOpenOutlined } from '@ant-design/icons';

const ComplianceCard = ({ item }) => {
  return (
    <Card
      style={{
        background: '#ffffff',
        borderRadius: 20,
        textAlign: 'left',
        padding: '20px',
        height: '170px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden'
      }}
      hoverable
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flex: 1,
          gap: '10px'
        }}
      >
        {/* Title and Count Section */}
        <div
          style={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}
        >
          <h3
            style={{
              fontSize: '1.05rem',
              color: '#333',
              margin: 0,
              fontWeight: 500,
              lineHeight: 1.4,
              wordBreak: 'break-word' // ✅ full text wraps neatly
            }}
          >
            {item.title}
          </h3>

          <h1
            style={{
              fontSize: '2.2rem',
              fontWeight: '700',
              color: '#2196F3',
              marginTop: 12,
              marginBottom: 0,
              lineHeight: 1.2
            }}
          >
            {item.count ?? 0}
          </h1>
        </div>

        {/* Icon container */}
        <div
          style={{
            backgroundColor: `${item.iconBg || '#ffecec'}`,
            borderRadius: '12px',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: 48,
            height: 48
          }}
        >
          {item.icon ? (
            <span
              style={{
                fontSize: '28px',
                color: item.iconColor || '#ff4d4f',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {item.icon}
            </span>
          ) : (
            <FolderOpenOutlined
              style={{ fontSize: '28px', color: '#ff4d4f' }}
            />
          )}
        </div>
      </div>
    </Card>
  );
};

export default ComplianceCard;
